var _a;
// Types
import { PopupAlignmentValues, PopupPlacementValues } from '../types/PopupMechanismProps';
/**
 * @description This is used to position the popup
 *  in the center of the targeted element
 *
 * @param {number} x - x position of targeted element
 * @param {number} y - y position of targeted element
 * @param {number} width - width of targeted element
 * @param {number} height - height of targeted element
 * @param {number} spaceBetweenElement - space between targeted element and popup
 *  (or when the popup has margins on it)
 *  - this is needed to translate the element left / right / up / down
 * @param {PopupAlignments} alignment - alignment to left / right / center of targeted element
 *
 * @returns { left, top, right, transform, arrowCenter }
 * Left / top represent the position of the popup (and whether it lies left / right / center)
 * Transform aligns the popup to the targeted element
 * arrowCenter represents the position of the arrow relative to position of the popup
 */
export var popupPlacement = (_a = {},
    _a[PopupPlacementValues.TOP] = function (x, y, width, height, spaceBetweenElement, alignment) {
        switch (alignment) {
            case PopupAlignmentValues.LEFT:
                return {
                    left: x,
                    top: y,
                    right: 'auto',
                    transform: "translateY(calc(-100% - " + spaceBetweenElement + "px))",
                    arrowCenter: width / 2 + "px",
                };
            case PopupAlignmentValues.RIGHT:
                return {
                    left: 'auto',
                    top: y,
                    right: "calc(100% - " + (x + width) + "px)",
                    transform: "translateY(calc(-100% - " + spaceBetweenElement + "px))",
                    arrowCenter: "calc(100% - " + width / 2 + "px)",
                };
            case PopupAlignmentValues.CENTER:
            default:
                return {
                    left: x + width / 2,
                    top: y,
                    right: 'auto',
                    transform: "translate(-50%, calc(-100% - " + spaceBetweenElement + "px))",
                    arrowCenter: '50%',
                };
        }
    },
    _a[PopupPlacementValues.BOTTOM] = function (x, y, width, height, spaceBetweenElement, alignment) {
        switch (alignment) {
            case PopupAlignmentValues.LEFT:
                return {
                    left: x,
                    top: y + height,
                    right: 'auto',
                    transform: "translateY(" + spaceBetweenElement + "px)",
                    arrowCenter: width / 2 + "px",
                };
            case PopupAlignmentValues.RIGHT:
                return {
                    left: 'auto',
                    top: y + height,
                    right: "calc(100% - " + (x + width) + "px)",
                    transform: "translateY(" + spaceBetweenElement + "px)",
                    arrowCenter: "calc(100% - " + width / 2 + "px)", // relative to popup
                };
            case PopupAlignmentValues.CENTER:
            default:
                return {
                    left: x + width / 2,
                    top: y + height,
                    right: 'auto',
                    transform: "translate(-50%, " + spaceBetweenElement + "px)",
                    arrowCenter: '50%',
                };
        }
    },
    // Left and right placement ignore alignment (will always be centered in the middle for now)
    _a[PopupPlacementValues.LEFT] = function (x, y, width, height, spaceBetweenElement) { return ({
        left: x,
        top: y + height / 2,
        right: 'auto',
        transform: "translate(calc(-100% - " + spaceBetweenElement + "px), -50%)",
        arrowCenter: '0px', // ignored
    }); },
    _a[PopupPlacementValues.RIGHT] = function (x, y, width, height, spaceBetweenElement) { return ({
        left: x + width,
        top: y + height / 2,
        right: 'auto',
        transform: "translate(" + spaceBetweenElement + "px, -50%)",
        arrowCenter: '0px', // ignored
    }); },
    _a);
//# sourceMappingURL=popupPlacement.js.map